import React from 'react';
import cx from 'classnames';

import { ArrowDownIcon } from '@motorway/motorway-storybook-cra';

import styles from './ExpandableIcon.module.scss';

type ExpandableIconProps = {
	className?: Nullable<string>;
	expanded?: boolean;
	icon?: React.FC<React.SVGProps<SVGSVGElement>> | null;
	noTransition?: boolean;
};

const ExpandableIcon: React.FC<ExpandableIconProps> = ({
	className = null,
	expanded = true,
	icon = null,
	noTransition = false,
}) => (
	<div
		className={cx(styles.icon, className, {
			[styles.expanded]: expanded,
			[styles.noTransition]: noTransition,
		})}
		data-testid="expandable-icon"
	>
		{icon ? <>{icon}</> : <ArrowDownIcon />}
	</div>
);

export default ExpandableIcon;
